import { has } from 'lodash/fp';

const getChoice = (choices, choice) => (has(choice, choices) ? choices[choice] : '');

export default getChoice;
